import { AuthCredentialsContext } from 'components/AuthCredentialsProvider'
import { useContext } from 'react'

export function useAuthCredentials() {
  return useContext(AuthCredentialsContext)
}
